import moment from "../utils/moment";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Utils } from "../utils";
import Field from "./Field";

interface InputProps {
  label?: React.ReactNode;
  value?: string;
  border?: string;
  margin?: string;
  placeholder?: string;
  svg?: React.ReactNode;
  icon?: string;
  name?: string;
  onChange?: (e: any) => void;
  showIcon?: boolean;
  showTimeInput?: boolean;
  hint?: string;
  error?: string;
  required?: boolean;
  minDate?: Date;
  maxDate?: Date;
  filterTime?: (date: Date) => boolean;
  filterDate?: (date: Date) => boolean;
}

const InputDate: React.FC<InputProps> = ({
  label,
  value,
  placeholder,
  svg,
  border,
  margin,
  icon = "bi-calendar3",
  name,
  onChange,
  showIcon = false,
  showTimeInput = false,
  hint = "",
  error,
  required,
  minDate = undefined,
  maxDate = undefined,
  filterTime,
  filterDate,
  ...rest
}) => {
  return (
    <Field
      label={label}
      margin={margin}
      icon={showIcon && !svg ? icon : undefined}
      iconNode={showIcon ? svg : undefined}
      hint={hint}
      error={error}
      required={required}
    >
      <DatePicker
        isClearable={false}
        className={`form-control ${border || ""}`}
        name={name}
        placeholderText={placeholder}
        selected={value ? new Date(value) : null}
        onChange={(date: any) =>
          onChange
            ? onChange({
                target: {
                  name: name,
                  value: moment(date).toISOString(),
                },
              })
            : null
        }
        showTimeSelect={showTimeInput}
        timeIntervals={60}
        showMonthDropdown
        showYearDropdown
        scrollableYearDropdown
        dateFormat={
          showTimeInput
            ? Utils.dateTimeFormatForPicker
            : Utils.dateFormatForPicker
        }
        autoComplete="off"
        autoFocus={false}
        minDate={minDate}
        maxDate={maxDate}
        filterTime={filterTime}
        filterDate={filterDate}
        {...rest}
      />
    </Field>
  );
};

export default InputDate;
